// extracted by mini-css-extract-plugin
export default {"inlineActions":"HoverActionsVirtualTable_inlineActions__85I3-","contextActions":"HoverActionsVirtualTable_contextActions__7nsRY"};